/** MFA (TOTP) der eigenen Anmeldung – Umsetzung über Amplify in auth.ts, im Mock in api/mock.ts. */
export interface Mfa {
  status(): Promise<{ enabled: boolean }>;
  /** Startet die Einrichtung; liefert das Geheimnis für die Authenticator-App. */
  begin(): Promise<string>;
  verify(code: string): Promise<void>;
}

export function otpauthUri(secret: string, account: string, issuer = 'Betriebsam'): string {
  return `otpauth://totp/${encodeURIComponent(`${issuer}:${account}`)}?secret=${secret}&issuer=${encodeURIComponent(issuer)}`;
}
